import '../../assets/index27.css';var H = Object.defineProperty, R = Object.defineProperties;
var j = Object.getOwnPropertyDescriptors;
var s = Object.getOwnPropertySymbols;
var f = Object.prototype.hasOwnProperty, F = Object.prototype.propertyIsEnumerable;
var x = (e, r, t) => r in e ? H(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, T = (e, r) => {
  for (var t in r || (r = {}))
    f.call(r, t) && x(e, t, r[t]);
  if (s)
    for (var t of s(r))
      F.call(r, t) && x(e, t, r[t]);
  return e;
}, h = (e, r) => R(e, j(r));
var b = (e, r) => {
  var t = {};
  for (var o in e)
    f.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
  if (e != null && s)
    for (var o of s(e))
      r.indexOf(o) < 0 && F.call(e, o) && (t[o] = e[o]);
  return t;
};
import { jsxs as C, jsx as a } from "react/jsx-runtime";
import A, { useState as I } from "react";
import { ErrorMessage as M } from "../../molecules/ErrorMessage/index.js";
import { Label as O } from "../Label/index.js";
import { Button as Q } from "../Button/index.js";
import { XMarkFarFAIcon as P } from "../Icons/index.js";
import { T as D } from "../../index-eVpm_et2.js";
import { T as J } from "../../Textarea-LPIXpNZY.js";
const L = "TextField-module__root___9xSbN", X = "TextField-module__wrapper___fLJF-", Y = "TextField-module__input___shQrf", q = "TextField-module__section___PMsf6", G = "TextField-module__label___yB4jx", K = "TextField-module__error___sL5lp", U = "TextField-module__description___uE3y4", Z = "TextField-module__textFieldWrapper___-QVQ9", ee = "TextField-module__characterCountContainer___OR9eO", te = "TextField-module__resizable___cVY6c", re = "TextField-module__resizeHandle___-SIBV", i = {
  root: L,
  wrapper: X,
  input: Y,
  section: q,
  label: G,
  error: K,
  description: U,
  textFieldWrapper: Z,
  characterCountContainer: ee,
  resizable: te,
  resizeHandle: re
}, fe = A.forwardRef((ie, S) => {
  var u = ie, {
    error: e,
    rightSection: r,
    multiline: t,
    maxRows: o = 5,
    minRows: v = 1,
    label: c,
    withAsterisk: oe,
    required: z,
    className: w,
    characterCount: y,
    maxLength: _,
    value: g = "",
    onChange: n,
    resizable: d,
    width: B,
    clearable: E
  } = u, N = b(u, [
    "error",
    "rightSection",
    "multiline",
    "maxRows",
    "minRows",
    "label",
    "withAsterisk",
    "required",
    "className",
    "characterCount",
    "maxLength",
    "value",
    "onChange",
    "resizable",
    "width",
    "clearable"
  ]);
  const [p, m] = I(g), V = (l) => {
    m(l.target.value), n && n(l);
  }, W = (l) => {
    l.preventDefault(), l.stopPropagation(), m(""), n && n({
      target: { value: "" },
      currentTarget: { value: "" }
    });
  }, $ = typeof c == "string" ? /* @__PURE__ */ a(O, { label: c, withAsterisk: z }) : c, k = E && p && /* @__PURE__ */ a(D, { label: "Clear", position: "bottom", children: /* @__PURE__ */ a(
    Q,
    {
      variant: "tertiary",
      size: "sm",
      onClick: W,
      "aria-label": "Clear",
      children: /* @__PURE__ */ a(P, {})
    }
  ) }) || r;
  return /* @__PURE__ */ C("div", { className: i.textFieldWrapper, children: [
    /* @__PURE__ */ a(
      J,
      h(T({
        classNames: {
          root: `${i.root} ${w || ""}`,
          input: `${i.input} ${t && d ? i.resizable : ""}`,
          wrapper: i.wrapper,
          section: i.section,
          label: i.label,
          error: i.error,
          description: i.description
        },
        inputWrapperOrder: ["label", "input", e ? "error" : "description"],
        autosize: !0,
        maxRows: o,
        minRows: v,
        error: e && /* @__PURE__ */ a(M, { error: e }),
        value: p,
        onChange: V,
        maxLength: _,
        style: { width: B }
      }, N), {
        ref: S,
        component: t ? void 0 : "input",
        label: $,
        rightSection: k
      })
    ),
    y && /* @__PURE__ */ a("div", { className: i.characterCountContainer, children: /* @__PURE__ */ C("span", { children: [
      p.length,
      _ ? ` / ${_}` : ""
    ] }) }),
    t && d && /* @__PURE__ */ a("div", { className: i.resizeHandle })
  ] });
});
export {
  fe as TextField
};
